import React from 'react'
import { LvpMarginWrapper } from '../Layouts/LargeVideoPlayerLayout'

import * as Styled from './styled'

interface Props {
  content: string
  advertPlacement?: string
}

const SeoContent: React.FunctionComponent<Props> = ({
  content,
  advertPlacement,
}: Props) => {
  return (
    <LvpMarginWrapper>
      {advertPlacement ? <Styled.Advert placement={advertPlacement} /> : null}
      <Styled.Wrapper dangerouslySetInnerHTML={{ __html: content }} />
    </LvpMarginWrapper>
  )
}

export default SeoContent
